import api from "../../APIIntercepter";

async function getSeminarsAdminAPI() {
  const res = await api.get("/seminars/admin");
  return res.data;
}

async function createSeminarAPI(params) {
  const res = await api.post("/seminars/admin", params);
  return res.data;
}

async function updateSeminarAPI(params) {
  const res = await api.put("/seminars/admin", params);
  return res.data;
}

async function deleteSeminarAPI(seminarId) {
  const res = await api.delete("/seminars/admin?id=" + seminarId);
  return res.data;
}

async function getSeminarFilesAPI(seminarId) {
  const res = await api.get("/seminarfiles?id=" + seminarId);
  return res.data;
}

async function createSeminarFilesAPI(params) {
  const res = await api.post("/seminarfiles/admin", params);
  return res.data;
}

async function updateSeminarFilesAPI(params) {
  const res = await api.put("/seminarfiles/admin", params);
  return res.data;
}

async function deleteSeminarFilesAPI(id) {
  const res = await api.delete("/seminarfiles/admin?id=" + id);
  return res.data;
}

async function getSeminarStudentsAPI(seminarId) {
  const res = await api.get("/studentseminarassign/admin/getStudentInformation/" + seminarId + "/2");
  return res.data;
}

async function assignSeminarStudentAPI(params) {
  const res = await api.post("/studentseminarassign/admin", params);
  return res.data;
}

async function removeSeminarStudentAPI(id) {
  const res = await api.post("/studentseminarassign/admin/unassign/"+id);
  return res.data;
}

export {
  getSeminarsAdminAPI,
  createSeminarAPI,
  updateSeminarAPI,
  deleteSeminarAPI,
  getSeminarFilesAPI,
  createSeminarFilesAPI,
  updateSeminarFilesAPI,
  deleteSeminarFilesAPI,
  getSeminarStudentsAPI,
  assignSeminarStudentAPI,
  removeSeminarStudentAPI,
};
